import { FormattedMessage } from "react-intl";

import { InputField } from "@ps-design-system/components/Input";
import { Text } from "@ps-design-system/components/Text";
import LightbulbIcon from "@ps-design-system/icons/Lightbulb/Lightbulb32";

import { getAreaUnit } from "~/i18n/i18n.utils";

import { MAX_SIZE } from "../SpaceDetailsForm.schema";

type SizeFieldProps = {
  spaceCountry: string;
};

const AREA_UNIT_SUFFIX: Record<"sqft" | "sqm", string> = {
  sqft: "sq ft",
  sqm: "m²",
};

const SizeField = ({ spaceCountry }: SizeFieldProps) => {
  const areaUnit = getAreaUnit(spaceCountry);

  return (
    <div className="tw-flex tw-flex-col tw-gap-16">
      <div className="tw-flex tw-flex-col tw-gap-8">
        <Text typeface="headline-4-b" element="h2" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_details.size_header"
            defaultMessage="How big is the space guests can book?"
          />
        </Text>
        <Text typeface="body-2" element="p" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_details.size_text"
            defaultMessage="Please only include the size of the space that guests can use during their booking."
          />
        </Text>
      </div>

      <Text
        element="p"
        className="tw-m-0"
        prefix={
          <LightbulbIcon className="tw-flex-shrink-0 tw-text-yellow-600" />
        }
      >
        <FormattedMessage
          id="hosting.space_details.size_example"
          defaultMessage="Example: If your space is 2,000 sq ft, but guests are booking a 500 sq ft conference room, you would enter “500”."
        />
      </Text>

      <InputField
        fullWidth
        type="number"
        name="size"
        suffix={AREA_UNIT_SUFFIX[areaUnit]}
        placeholder="500"
        min={1}
        max={MAX_SIZE}
        required
        testId="space-details-form-size-input"
      />
    </div>
  );
};

export { SizeField };
